<template lang="html">
  <div class="container" id="text-page">
    <h1 class="page-title txt-black">Aviso de privacidad hules automotrices becerra</h1>

    <br />
    <p>
       Este Aviso describe la forma en que recabamos y usamos los datos personales que usted nos brinda, uso que será el necesario, adecuado y relevante en relación con las finalidades determinadas previstas en este documento. También describe qué tipo de datos son y qué opciones tiene para limitar el uso de dichos datos. Hules Automotrices Becerra, con domicilio en Av. Cruz del Sur 3237, Col. Jardines del Sur, C.P. 44950, Guadalajara, Jalisco, México. es responsable de recabar sus datos personales, del uso que se le de a los mismos y de su protección. Su información personal será utilizada para proveer los servicios y productos que ha solicitado, informarle sobre cambios en los mismos y evaluar la calidad del servicio que le brindamos.
    </p>

    <br />
    <p>
      Para las finalidades antes mencionadas, requerimos obtener los siguientes datos personales, considerados como sensibles según la Ley Federal de Protección de Datos Personales en Posesión de los Particulares:
    </p>
    <ol>
      <li>
        Información de contacto (Nombre, Email, Dirección, Teléfono, Celular y Fax).
      </li>
      <li>
        Información financiera y medios de pago (Tarjeta de crédito, débito y cheques).
      </li>
      <li>
        Información Fiscal (RFC, Email, Razón o Denominación social y Domicilio fiscal).
      </li>
      <li>
        Credenciales de acceso a servicios en línea (Usuario y contraseña).
      </li>
      <li>
        Identificación en Redes Sociales (Facebook, Instagram, Twitter, LinkedIn, Google+).
      </li>
    </ol>

    <br />
    <p>
      Dichos datos serán recabados de distintas formas como las que se describen a continuación:
    </p>
    <ol>
      <li>
        Cuando visita nuestro sitio de Internet o utiliza nuestros servicios en línea.
      </li>
      <li>
        Por teléfono o fax.
      </li>
      <li>
        Cuando obtenemos información a través de otras fuentes de acceso público que están permitidas por la ley (Directorios telefónicos o laborales, sitios web, etc).
      </li>
      <li>
        Cuando usted directamente llena información dentro de nuestros formularios electrónicos.
      </li>
    </ol>

    <br />
    <p>
      Los datos personales que Hules Automotrices Becerra obtendrá serán utilizados para los siguientes fines:
    </p>
    <ol>
      <li>
        Promoción y mercadeo de productos y servicios.
      </li>
      <li>
        Elaborar estudios y programas que son necesarios para determinar hábitos de uso y consumo.
      </li>
      <li>
        Ofrecerle nuevos productos y servicios a la medida de sus intereses y necesidades.
      </li>
      <li>
        Realizar evaluaciones periódicas de nuestros productos y servicios a efecto de mejorar la calidad de los mismo.
      </li>
      <li>
        Notificarle sobre nuevos servicios o productos que tengan relación con los ya contratados o adquirido.
      </li>
      <li>
        Boletines y comunicados sobre nuestra organización.
      </li>
      <li>
        Cookies, web beacons y JavaScript: Las cookies son archivos de texto que son descargados automáticamente y almacenados en el disco duro del equipo de cómputo del usuario al navegar en una página de Internet específica, que permiten recordar al servidor de Internet algunos datos sobre este usuario, entre ellos, sus preferencias para la visualización de las páginas en ese servidor, nombre y contraseña. Por su parte, las web beacons son imágenes insertadas en una página de Internet o correo electrónico, que puede ser utilizado para monitorear el comportamiento de un visitante, como almacenar información sobre la dirección IP del usuario, duración del tiempo de interacción en dicha página y el tipo de navegador utilizado, entre otros.
      </li>
    </ol>

    <br />
    <p>
       Le informamos que utilizamos cookies y web beacons para obtener información personal de usted, como la siguiente:
    </p>
    <ol>
      <li>
        Su tipo de navegador y sistema operativo.
      </li>
      <li>
        Las páginas de Internet que visita.
      </li>
      <li>
        Los vínculos que sigue.
      </li>
      <li>
        La dirección IP
      </li>
    </ol>

    <br />
    <p>
      Usted tiene derecho de acceder, rectificar y cancelar sus datos personales, así como de oponerse al tratamiento de los mismos o revocar el consentimiento que para tal fin nos haya otorgado, a través de los procedimientos que hemos implementado. Para conocer dichos procedimientos, los requisitos y plazos, se puede poner en contacto con nuestro departamento de datos personales en los teléfonos 01 (33) 36-46-09-45, 01 (33) 35-87-77-36 o 01 (33) 33-67-48-95 o en el correo electrónico: contacto@hulesbecerra.com
    </p>

    <br />
    <p>
      Asimismo, le informamos que sus datos personales pueden ser transferidos y tratados dentro y fuera del país, por personas distintas a esta empresa como lo son:
    </p>
    <ol>
      <li>
        Sociedades del mismo grupo del responsable que opere bajo los mismos procesos y políticas internas; para dar cumplimiento a la relación jurídica adquirida con el Titular.
      </li>
      <li>
        Entidades del sector público, para dar cumplimiento a la legislación vigente, así como a la relación jurídica con el Titular.
      </li>
    </ol>

    <br />
    <p>
      En ese sentido, su información puede ser compartida para mejorar la calidad de nuestro servicio y proveerle productos de alta calidad. Si usted no manifiesta su oposición para que sus datos personales sean transferidos, se entenderá que ha otorgado su consentimiento para ello.
    </p>

    <br />
    <p>
      Si usted desea dejar de recibir mensajes promocionales de nuestra parte puede solicitarlo a través de los teléfonos 01 (33) 36-46-09-45, 01 (33) 35-87-77-36 o 01 (33) 33-67-48-95 o envíar un correo electrónico a contacto@hulesbecerra.com
    </p>

    <br />
    <p>
      Si después de haber ejercido sus Derechos de Protección de Datos, por medio de los mecanismos establecidos en este Aviso de Privacidad, considera que su derecho de protección de datos personales ha sido lesionado por alguna conducta u omisión de nuestra parte; o cuenta con evidencia de que en el tratamiento de sus datos personales existe alguna violación a las disposiciones previstas en la LFPDPPP, le invitamos a ponerse en contacto nuevamente con nosotros para agotar todos los procedimientos internos a efecto de satisfacer plenamente su solicitud. De no ser el caso, usted podrá interponer la queja correspondiente ante el IFAI.
    </p>

    <br />
    <p>
      Cualquier modificación a este aviso de privacidad podrá consultarla en www.hulesbecerra.com
    </p>

    <br />
    <p>
      Fecha última actualización [20/febrero/2016]
    </p>
  </div>
</template>

<script>
export default {
}
</script>
